/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import cx from "classnames";
import { useTranslation } from "next-i18next";
import { useEffect } from "react";

import {
  IUserDeviceModel,
  useDispatch,
  UserStore,
  useSelector,
} from "@nf/common";
import { ITableColumn, Table } from "components/Table";
import ActionsHandler from "components/ActionsHandler";
import Tooltip from "components/Tooltip";

import IconX from "../../../resources/icons/close-dark.svg";

import styles from "./SettingsDevices.module.scss";

export const SettingsDevices = () => {
  const dispatch = useDispatch();
  const {
    Data,
    Error: error,
    IsProcessing: isLoading,
  } = useSelector((state) => state.user.devices);
  const { t } = useTranslation("translations");

  const onDelete = (id: string) =>
    dispatch(UserStore.Actions.deleteUserDevice(id));

  useEffect(() => {
    dispatch(UserStore.Actions.getUserDevices());
  }, []);

  const playbackDevices = Data?.filter((device) => device.PlayDevice);

  const columns: ITableColumn<IUserDeviceModel>[] = [
    {
      title: t("web_devices_device"),
      key: "device",
      render: ({ Name }) => Name,
      width: 230,
      align: "left",
    },
    {
      key: "delete",
      render: ({ Id, Name, CurrentDevice }) =>
        !CurrentDevice && (
          <Tooltip content={t("web_devices_icon_delete")}>
            <button
              type="button"
              aria-label={`${t("web_devices_icon_delete")} ${
                Name ?? ""
              }`.trim()}
              className={cx(styles.Action, styles.Delete)}
              onClick={() => onDelete(Id)}
            >
              <IconX />
            </button>
          </Tooltip>
        ),
    },
  ];

  return (
    <div className={styles.Container}>
      <p>{t("web_devices_info")}</p>
      <p>{t("web_devices_list_description")}</p>
      <ActionsHandler isLoading={isLoading} error={error}>
        <Table
          className={styles.Table}
          columns={columns}
          data={playbackDevices}
          rowKey="Id"
          emptyText={t("web_my_account_menu_devices_no_data_text")}
        />
      </ActionsHandler>
    </div>
  );
};

export default SettingsDevices;
